import { useEffect, useState } from 'react';
import { useExternalAccessValue } from '@24i/nxg-sdk-smartott-shared/src/hooks/subscriptions';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';
import useAvailableSubscriptionsQuery from '../../../../../hooks/query/subscriptions/useAvailableSubscriptions';
import { PurchaseSubscriptionScreenProps } from '../../../../../screens/PurchaseSubscriptionScreen/types';
import { useAppNavigation } from '../../../../../context/AppNavigation';
import { setStripeProductDataToStorage } from '../../../utils';
import { useStripe } from '../../../../../context/StripeProvider/index.web';

export const useViewModel = (props: PurchaseSubscriptionScreenProps) => {
    const { getExternalAccessValue } = useExternalAccessValue();
    const { stripePromise } = useStripe();
    const { previousRoute } = useAppNavigation();
    const purchaseDataClient = usePurchaseData();
    const { data: subscriptionData } = useAvailableSubscriptionsQuery();
    const [clientSecret, setClientSecret] = useState<string | null>(null);
    const productId = props?.query?.offerId;

    const createCheckoutSession = async () => {
        try {
            const foundSubscription = subscriptionData?.subscriptions.find(
                (v) => v.id === productId || v.externalAccessValue === productId
            );

            const productSubscription = getExternalAccessValue(productId, 'stripe') as {
                priceId?: string;
                productId?: string;
            } | null;
            if (
                !productSubscription ||
                (typeof productSubscription !== 'object' && !foundSubscription?.id)
            )
                return;

            const checkoutSession = await purchaseDataClient.createStripeCheckoutSession({
                productId: foundSubscription?.id as string,
                stripePriceId: productSubscription.priceId as string,
                stripeProductId: productSubscription.productId as string,
            });

            setClientSecret(checkoutSession.client_secret || null);
        } catch (e) {
            setClientSecret(null);
        }
    };

    useEffect(() => {
        if (!productId || !subscriptionData?.subscriptions.length) return;

        setStripeProductDataToStorage(productId, previousRoute).catch();
        createCheckoutSession().catch();
    }, [productId, subscriptionData]);

    return { ...props, clientSecret, stripePromise };
};
